import React, { useState } from "react";
import { Box, Grid, Switch as SwitchMui, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
// import CustomTextField from "../textField";
import Toast from "../common/Toast";
import InputField from "../common/new/InputField/InputField";
import Colors from "../../theme/colors";

function RejectTransferRequest({ selectedItem, onFinalSubmit }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [remarks, setremarks] = useState("");
  const [checked, setChecked] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const handleSwitchChange = (event) => {
    setChecked(event.target.checked);
  };
  return (
    <Box sx={{ p: "1rem" }}>
      <Box sx={{ minHeight: 0 }}>
        <Box sx={{ display: "flex", mb: "40px" }}>
          <Box
            sx={{
              maxWidth: "215px",
              fontWeight: "500",
              fontSize: "16px",
              lineHeight: "24px",
              color: "#171717",
            }}
          >
            {" "}
            Does above introduction belong to your structure?
          </Box>
          <SwitchMui checked={checked} onChange={handleSwitchChange} />
        </Box>
        <Grid md={8} xs={8}>
          <InputField
            fullWidth
            required
            type="text"
            defaultValue=""
            key="remark"
            name="remark"
            label="Your Remark"
            value={remarks}
            onChange={(e) => setremarks(e.target.value)}
          />
        </Grid>
        <Grid item md={12} xs={12}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: Colors.midnightBlue,
              borderRadius: "2rem",
              px: "2rem",
              py: ".5rem",
              fontSize: "18px",
              fontWeight: "500",
              textTransform: "capitalize",
              mt: "40px",
            }}
            onClick={() => {
              if (!remarks) {
                setShowToast({
                  message: "Remarks should not be empty!",
                  severity: "error",
                });
              } else {
                onFinalSubmit(
                  dispatch,
                  { message: remarks, event: "rejection" },
                  selectedItem,
                  navigate,
                  setShowToast
                );
              }
            }}
          >
            Reject
          </Button>
          <Toast
            open={!!showToast}
            severity={showToast?.severity || ""}
            message={showToast?.message || ""}
            handleClose={() => {
              setShowToast(null);
            }}
          />
        </Grid>
      </Box>
    </Box>
  );
}

const propTypes = {
  selectedItem: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  onFinalSubmit: PropTypes.func.isRequired,
};

RejectTransferRequest.propTypes = propTypes;

export default RejectTransferRequest;
